import { State as AccessCodeDetailsState } from '../reducers/access-code-details-reducer';
import { Selector } from '@ngrx/store';
export const getIsActive: Selector<AccessCodeDetailsState, boolean> = (state: AccessCodeDetailsState) => state.isActive;
